import { render, staticRenderFns } from "./milestone-navigation-tab.vue?vue&type=template&id=3b068454&"
import script from "./milestone-navigation-tab.vue?vue&type=script&lang=ts&"
export * from "./milestone-navigation-tab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports